import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

import {
  AnyOperationId,
  OperationResult,
  OperationVariables,
} from '../../generated/operation-ids';
import { get } from './graphql-fetch';

/**
 * Run a persisted graphql query and manage its state with react-query.
 *
 * The drop-in replacement for the graphql-codegen react-query hooks, which post
 * the query text and therefore require the `arbitrary graphql requests`
 * permission.
 */
export function usePersistedQuery<T extends AnyOperationId>(
  id: T,
  variables?: OperationVariables<T>,
  options?: Omit<UseQueryOptions<OperationResult<T>>, 'queryKey' | 'queryFn'>,
): UseQueryResult<OperationResult<T>> {
  return useQuery<OperationResult<T>>(
    [id, variables],
    () => get(id, variables),
    options,
  );
}
